"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPSDK = void 0;
const one_point_sdk_1 = __importDefault(require("@fozg/one-point-sdk"));
exports.OPSDK = new one_point_sdk_1.default("https://fozg.net/opapi", process.env.REACT_APP_TOKEN);
//# sourceMappingURL=OnePointSDKBase.js.map